module.exports = __webpack_public_path__ + "img/bg-mota-2.961a410f.jpg";